/**
 * EAA-1212: the effective size cap and `accept` filter for a media upload, read from
 * the app's configured upload limits (`@ai-content-hub/shared-config`).
 *
 * The FE keeps a cap PER media type (image 10MB, audio 50MB, video 100MB) while the
 * server has ONE cap for the whole media endpoint. The effective cap is the smaller of
 * the two: the editor must never allow more than the server accepts, and raising the
 * server cap must not loosen the per-type product caps.
 */

import {
    capLimitBytes,
    mediaAcceptAttr,
    useUploadLimits,
    type UploadLimits,
} from '@ai-content-hub/shared-config';

import { ACCEPT_STRINGS, DEFAULT_MAX_SIZES, type MediaType } from './schema';

export interface MediaUploadLimit {
    maxSize: number;
    accept: string;
}

export function mediaUploadLimitFor(mediaType: MediaType, limits: UploadLimits): MediaUploadLimit {
    return {
        maxSize: capLimitBytes(DEFAULT_MAX_SIZES[mediaType], limits.mediaMaxSizeMb),
        accept: mediaAcceptAttr(limits, mediaType, ACCEPT_STRINGS[mediaType]),
    };
}

export function useMediaUploadLimits(mediaType: MediaType): MediaUploadLimit {
    return mediaUploadLimitFor(mediaType, useUploadLimits());
}
